import { render } from "./index.vue?vue&type=template&id=e5397902&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e5397902&lang=scss"
import "./index.vue?vue&type=style&index=1&id=e5397902&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5397902"],['__file',"src/vab/components/VabHeader/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5397902"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5397902', __exports__)) {
    console.log('reload')
    api.reload('e5397902', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e5397902&scoped=true", () => {
    console.log('re-render')
    api.rerender('e5397902', render)
  })

}


export default __exports__